export class CategorieModel {
    public id?: number;
    public title?: string;
    public image?: string;
    public contentType?: string;
    public nomeArquivo?: string;
}
